/**
 * check user required data
 */
export default {
  isValid (state) {
    const userState = state.user.userInfo

    /* Name, Nickname, Phone */
    if (!(userState.nickname || userState.name)) {
      return false
    }
    if (!userState.cellphone) {
      return false
    }

    if (!userState.city || !userState.district) {
      return false
    }

    return true
  },
  isValidBaseInfo (state) {
    const userState = state.user.userInfo
    /* Name, Nickname, Phone */
    if (!(userState.nickname && userState.name)) {
      return false
    }
    if (!userState.cellphone) {
      return false
    }
    return true
  },
  isValidAdr (state) {
    const userState = state.user.userInfo
    if (!userState.others) {
      return false
    }

    if (userState.others) {
      const {addresses} = userState.others
      if (!addresses) {
        return false
      }
      if (addresses) {
        const {users, things, rcvs} = addresses
        /* Address( users, things, rcvs ) */
        if (!users || !users.city || !users.district || !users.address) {
          return false
        }
        if (!things || !things.city || !things.district || !things.address) {
          return false
        }
        if (!rcvs || !rcvs.city || !rcvs.district || !rcvs.address) {
          return false
        }
      }
    }
    return true
  },
  isNull (string) {
    if (string === 'NULL' || string === 'null') return false
    return string
  },
  isCellphoneVerified (state) {
    const userState = state.user.userInfo
    return userState.cellphone && userState.veriCell === 'Y'
  }
}
